import React from 'react';

import {Divider, Layout, Text} from '@phonectas/unifon-ui-kit';
import {useTranslation} from 'react-i18next';
import getEventType from '../../getEventTypes';
import {AccountFeed} from 'common/types/store/threeSixtyTypes';
import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import Skeleton from 'common/components/Skeleton';

interface EventsProps {
	events: AccountFeed | null;
	filters?: string[];
	// show?: boolean;
}

const Events: React.FC<EventsProps> = ({events, filters}) => {
	const [t] = useTranslation();
	const isLoading = useThreeSixtyNewStore((state) => state.isAccFeedLoading);

	if (isLoading) {
		return (
			<Layout direction="column" style={{padding: 0}} gap="none" fullWidth fullHeight>
				<Skeleton $noMargin $noPadding/>
			</Layout>
		);
	}

	if (events?.feed_entries?.length === 0) {
		return (
			<Layout direction="column" gap="none" fullWidth fullHeight>
				<Text variant="body1">{t('No events found')}</Text>
			</Layout>
		);
	}

	return (
		<Layout
			fullWidth
			fullHeight
			direction="column"
			nowrap
			autoOverflow
			id="events_wrapper"
			style={{
				paddingRight: '5px',
			}}
		>
			{events?.feed_entries?.map((event, index) => {
				const EventComponent = getEventType(event?.feed_type);
				return EventComponent ? (
					<Layout gap="sm" direction="column" fullWidth nowrap key={index}>
						<EventComponent
							key={index}
							data={event}
							id={event.id}
							filters={filters || []}
						/>
						{index !== events?.feed_entries.length - 1 && <Divider />}
					</Layout>
				) : null;
			})}
		</Layout>
	);
}

export default Events;
